/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { format } from 'date-fns';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Footer } from '@global-components/Footer';

import { maskPhone, removePhoneMask } from '@global-utils/masks/phone';

import { useToastStore } from '@global-stores/toast/useToast';

import { useUserRegister } from '@services/register';

import { RegisterScreenProps } from './types';
import { registerDefaultValues, registerSchema } from './validations';

const RegisterScreen = ({ roomData }: RegisterScreenProps): React.ReactElement => {
  const route = useRouter();
  const { mutate, isLoading } = useUserRegister();
  const [isAgreed, setIsAgreed] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: registerDefaultValues,
    resolver: yupResolver(registerSchema),
  });
  const { t } = useTranslation();

  const { toast } = useToastStore((state) => state);

  const { onChange, ...registerTelefone } = register(`telefone`);

  const onFormSubmit = handleSubmit(async (formData) => {
    mutate(
      {
        Nome: formData.nome,
        Empresa: formData.empresa,
        Telefone: removePhoneMask(formData.telefone),
        Email: formData.email,
        TipoDeUsuario: formData[`tipo-de-usuario`],
        Cidade: ``,
        Estado: ``,
        Pais: ``,
        WebcastID: roomData?.WebcastId?.toString(),
      },
      {
        onSuccess: (response) => {
          localStorage.setItem(
            `userData-${route?.query?.roomId}`,
            JSON.stringify({
              name: formData.nome,
              email: formData.email,
              userHash: response?.data?.token,
            }),
          );
          route.push(`/${route?.query?.roomId}/event-starts`);
        },

        onError: () => {
          toast(`Sem conexão`, `Cheque sua conexão e tente novamente.`, `error`);
        },
      },
    );
  });

  return (
    <>
      <main className="background">
        <div className="content">
          <div className="main-content">
            <div className=" details">
              <div>
                <div className="logo">
                  <img
                    src={`${roomData?.Style?.AccountImagesVirtualDirPath}/logo_interna.png`}
                    alt="Logo"
                  />
                </div>
                <h3 className="title">{roomData?.Titulo}</h3>
                <p className="description">{roomData?.Descricao}</p>
                <p className="start-date">
                  <strong> {t(`webcast.eventStarts.castStarts`)} </strong>
                  {roomData?.DataInicio &&
                    format(new Date(roomData?.DataInicio), t(`register.dateFormat`))}
                  {` `}
                  BRT
                </p>
              </div>
            </div>
            <div className="form-wrapper">
              <div className="form-container">
                <h3>{t(`register.initRegister`)}</h3>
                <h4>{t(`register.initRegisterText`)}</h4>
                <form id="registrationForm" onSubmit={onFormSubmit}>
                  <fieldset>
                    <div>
                      {Object.keys(errors).map((key) => (
                        <p key={key} className="text-danger" id="validationFormError">
                          {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            t(errors[key as keyof typeof registerDefaultValues]!.message!)
                          }
                        </p>
                      ))}
                    </div>
                    <div className="form-group font-registro-custom">
                      <label className="control-label" htmlFor="name">
                        <span>{t(`register.name`)}</span>
                        <span>*</span>
                      </label>
                      <input
                        maxLength={119}
                        className="form-control"
                        id="name"
                        type="text"
                        required
                        {...register(`nome`)}
                      />
                    </div>
                    <div className="form-group font-registro-custom">
                      <label className="control-label" htmlFor="email">
                        <span>{t(`register.email`)}</span>
                        <span>*</span>
                      </label>
                      <input
                        maxLength={119}
                        className="form-control"
                        id="email"
                        type="email"
                        required
                        {...register(`email`)}
                      />
                    </div>
                    <div className="form-group font-registro-custom">
                      <label className="control-label" htmlFor="company">
                        <span>{t(`register.company`)}</span>
                      </label>
                      <input
                        maxLength={119}
                        className="form-control"
                        id="company"
                        type="text"
                        {...register(`empresa`)}
                      />
                    </div>
                    <div className="form-group font-registro-custom">
                      <label className="control-label" htmlFor="phone">
                        <span>{t(`register.phone`)}</span>
                        <span>*</span>
                      </label>
                      <input
                        className="form-control"
                        id="phone"
                        type="text"
                        maxLength={200}
                        required
                        {...registerTelefone}
                        onChange={(e) => {
                          e.target.value = maskPhone(e.target.value);

                          onChange(e);
                        }}
                      />
                    </div>
                    <div className="form-group font-registro-custom">
                      <label htmlFor="tipo-de-usuario" className="control-label user-type">
                        <span>{t(`register.userType`)}</span>
                        <span>*</span>
                      </label>
                      <select
                        className="form-control"
                        id="tipo-de-usuario"
                        {...register(`tipo-de-usuario`)}
                      >
                        {roomData?.Tipos.map((tipo) => (
                          <option key={tipo.Id} value={tipo.Id}>
                            {tipo.Description}
                          </option>
                        ))}
                      </select>
                    </div>

                    <label style={{ cursor: `pointer`, padding: `8px 0px` }}>
                      <input
                        type="checkbox"
                        checked={isAgreed}
                        onChange={() => {
                          setIsAgreed(!isAgreed);
                        }}
                      />
                      <span style={{ fontSize: `13px` }}>
                        {` `}
                        {t(`register.acceptTerms`)}
                        <a href={t(`register.linkTerms`)} target="_blank" rel="noreferrer">
                          {` `}
                          {t(`register.privacyPolicy`)}
                        </a>
                        {` `}
                        {t(`register.useTermsAnd`)}
                        <a href={t(`register.linkTerms`)} target="_blank" rel="noreferrer">
                          {` `}
                          {t(`register.useTerms`)}
                        </a>
                        {` `} {t(`register.useTermsPrisma`)}.
                      </span>
                    </label>

                    <div className="clearfix">
                      <button
                        type="submit"
                        className="btn btn-register"
                        disabled={!isAgreed || isLoading}
                      >
                        {isLoading ? (
                          <div className="loader">{t(`register.loading`)}</div>
                        ) : (
                          t(`register.labelSubmit`)
                        )}
                      </button>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <style jsx>
          {`
            @import '/assets/css/register.css';
            @import url('${roomData?.Style?.AccountStyleVirtualFilePath[0]}');
          `}
        </style>
      </main>
      <div className="scroll-space" />
    </>
  );
};

export default RegisterScreen;
